(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quiz-allergies-and-sensitivities"]) return;
  try {
    
  document.getElementById("custom_allergy_issue").addEventListener('input', handleChangeAllergy)
  function handleChangeAllergy() {
    enableBtnForNontextType("allergies", "allergiesBtnDiv")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-health"]) return;
  try {
    
  document.getElementById("custom_heath_issue").addEventListener('input', handleChange)
  function handleChange() {
    enableBtnForNontextType("health_issues", "health_issuesBtnDiv")
  }

  } catch(e) { console.error(e); }
})();
})();
